var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 6,
    fill: "#E3EBFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 32H34V30C34 28.3431 32.6569 27 31 27C30.0444 27 29.1931 27.4468 28.6438 28.1429M29 32H19M29 32V30C29 29.3438 28.8736 28.717 28.6438 28.1429M19 32H14V30C14 28.3431 15.3431 27 17 27C17.9556 27 18.8069 27.4468 19.3562 28.1429M19 32V30C19 29.3438 19.1264 28.717 19.3562 28.1429M19.3562 28.1429C20.0935 26.301 21.8948 25 24 25C26.1052 25 27.9065 26.301 28.6438 28.1429M27 19C27 20.6569 25.6569 22 24 22C22.3431 22 21 20.6569 21 19C21 17.3431 22.3431 16 24 16C25.6569 16 27 17.3431 27 19ZM33 22C33 23.1046 32.1046 24 31 24C29.8954 24 29 23.1046 29 22C29 20.8954 29.8954 20 31 20C32.1046 20 33 20.8954 33 22ZM19 22C19 23.1046 18.1046 24 17 24C15.8954 24 15 23.1046 15 22C15 20.8954 15.8954 20 17 20C18.1046 20 19 20.8954 19 22Z",
    stroke: "#5556D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersDashboard);
export default __webpack_public_path__ + "static/media/users_dashboard.7aba3d47da864ef90998269fff015db4.svg";
export { ForwardRef as ReactComponent };